import React, { useState, useEffect, useCallback } from "react";
import Sidebar from "../../Components/Sidebar";
import { useNavigate } from "react-router-dom";
import { PiTextColumnsLight } from "react-icons/pi";
import { TbBusinessplan } from "react-icons/tb";
import { MdOutlineDeleteForever } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";
import DeletePopup from "../../Components/DeletePopup";
import EditLoanPopup from "./EditLoanPopup";
import { deleteLoanlist, fetchLoanData } from "../../redux/actions/loanAction";
import { useDispatch, useSelector } from "react-redux";
import PageComponent from "../../Components/PageComponent";
import { toast } from "react-hot-toast";  // Import toast

function AllLoans() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [selectedProgram, setSelectedProgram] = useState(null);
  const [refreshData, setRefreshData] = useState(false);

  const { data: loanList = [], loading, error } = useSelector((state) => state.loan.Loan || {});

  useEffect(() => {
    dispatch(fetchLoanData());
  }, [dispatch, refreshData]);

  useEffect(() => {
    console.log("Loan list data:", loanList); // Log loanList for debugging
  }, [loanList]);

  const handleDelete = (loan) => {
    setSelectedProgram(loan);
    setIsDeleteOpen(true);
  };

  const handleDeleteConfirm = () => {
    if (selectedProgram) {
      dispatch(deleteLoanlist(selectedProgram.id))
        .then(() => {
          toast.success("Loan deleted successfully"); // Use toast
          setIsDeleteOpen(false);
          setRefreshData(prev => !prev);
        })
        .catch((error) => {
          console.error("Error deleting loan:", error);
          toast.error("Error deleting the loan."); // Use toast
        });
    }
  };

  const handleEdit = (loan) => {
    setSelectedProgram(loan);
    setIsEditOpen(true);
  };

  const handleSaveEdit = useCallback(() => {
    console.log("handleSaveEdit called");  // Log for debugging
    setRefreshData(prev => !prev);
  }, [setRefreshData]);

  if (loading) return <div className="text-center text-gray-500">Loading loan schemes...</div>;
  if (error) return <div className="text-center text-red-500">Error: {error}</div>;

  return (
    <><PageComponent>
      <div className="flex w-screen h-screen bg-[#F8F7FA] overflow-hidden">
        <div className="fixed top-0 left-0 w-64 h-full bg-white shadow-md overflow-y-auto">
          <Sidebar />
        </div>
        <div className="flex-1 min-h-screen p-6 ml-64 overflow-auto">
          <div className="flex items-center space-x-2 text-3xl text-gray-500">
            <span>Academics & International</span>
            <span>/</span>
            <span className="text-black">Interest Free Loan Scheme</span>
          </div>

          <div className="flex items-center mt-4 space-x-4">
            <button
              className="flex items-center px-4 py-2 text-[#A8AAAE] rounded-lg shadow hover:bg-gray-100"
              onClick={() => navigate("/academics&international/loanScheme/addLoan")}
            >
              <TbBusinessplan className="mr-2" />
              Add Loan Scheme
            </button>
            <button
              className="flex items-center px-4 py-2 text-white bg-[#92288C] rounded-lg shadow hover:bg-[#6C0B67]"
              onClick={() => navigate("/academics&international/loanScheme/allLoans")}
            >
              <PiTextColumnsLight className="mr-2" />
              All Loan Schemes
            </button>
          </div>

          <div className="w-full p-6 mt-6 bg-white rounded-lg shadow-md">
            <h2 className="mb-4 text-xl font-semibold text-gray-700">Loan Schemes List</h2>
            <div className="overflow-x-auto max-h-96 sidebar-container">
              <table className="min-w-full border-collapse table-auto">
                <thead>
                  <tr className="text-left text-gray-600 bg-gray-100">
                    <th className="px-8 py-2 whitespace-nowrap">LOAN SCHEMES TITLE</th>
                    <th className="px-8 py-2 whitespace-nowrap">ACTIONS</th>
                  </tr>
                </thead>
                <tbody>
                  {loanList.length > 0 ? (
                    loanList.map((loan, index) => (
                      <tr key={loan.id || index} className="border-b border-gray-300">
                        <td className="px-8 py-2">{loan.title || "N/A"}</td>
                        <td className="flex items-center justify-start px-2 py-2 gap-x-2">
                          <button
                            type="button"
                            className="flex items-center px-5 py-1 text-gray-400 bg-gray-100 border border-gray-400 rounded"
                            onClick={() => handleDelete(loan)}
                          >
                            Delete
                            <MdOutlineDeleteForever className="w-5 h-5 ml-2" />
                          </button>
                          <button
                            type="button"
                            className="flex items-center px-5 py-1 border rounded text-primary-color border-primary-color bg-primary-color bg-opacity-10"
                            onClick={() => handleEdit(loan)}
                          >
                            Edit
                            <FaRegEdit className="w-4 h-4 ml-2" />
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="2" className="text-center text-gray-500">
                        No loan schemes available.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <DeletePopup
            title="Loan Schemes"
            isOpen={isDeleteOpen}
            onClose={() => setIsDeleteOpen(false)}
            onConfirm={handleDeleteConfirm}
            data={selectedProgram?.title || ""}
          />

          <EditLoanPopup
            isOpen={isEditOpen}
            onClose={() => setIsEditOpen(false)}
            onSave={handleSaveEdit}
            loanList={selectedProgram || {}}
          />
        </div>
      </div>
    </PageComponent></>
  );
}

export default AllLoans;